import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { userCheck } from "./helpers/userCheck/userCheck";
import WelcomePage from "./pages/WelcomePage/WelcomePage";
import {
    loginFalse,
    loginTrue,
    setUserCheckLoading,
} from "./redux/slices/isLogin/isLogin.slice";

const Login = () => {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState(searchParams.get("saml"));
    const tokenTrue = useSelector((state) => state.isLogin.value);
    const [redirectPage, setFbCode] = useState(searchParams.get("redirect_to"));
    const [response, setResponse] = useState("");
    const dispatch = useDispatch();
    // CookieHelper.js
    const setCookie = (name, value, days) => {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        const cookieValue =
            encodeURIComponent(value) +
            (days ? `; expires=${expires.toUTCString()}` : "");
        document.cookie = `${name}=${cookieValue}; path=/`;
    };
    useEffect(() => {
        if (token) {
            fetchData();
        }
    }, [token]);

    useEffect(() => {
        if (response) {
            const target = redirectPage ? `/${redirectPage}` : "/";
            window.location.replace(target);
        }
    }, [response, redirectPage]);

    // useEffect(() => {}, [fbCode]);
    // useEffect(() => {
    //   window.fbAsyncInit = () => {
    //     window.FB.init({
    //       appId: "1859955294113735",
    //       autoLogAppEvents: true,
    //       xfbml: true,
    //       version: "v13.0",
    //     });
    //     if (fbCode) {
    //       window.FB.getLoginStatus(function (response) {
    //         statusChangeCallback(response);
    //       });
    //     }
    //   };
    //   (function (d, s, id) {
    //     var js,
    //       fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) {
    //       return;
    //     }
    //     js = d.createElement(s);
    //     js.id = id;
    //     js.src = "https://connect.facebook.net/en_US/sdk.js";
    //     fjs.parentNode.insertBefore(js, fjs);
    //   })(document, "script", "facebook-jssdk");
    // }, []);

    // const statusChangeCallback = (response) => {
    // };

    const fetchData = async () => {
        let result;
        dispatch(setUserCheckLoading(true));
        try {
            result = await userCheck(token);
        } catch (error) {
            dispatch(loginFalse());
        }

        setResponse(result?.status);
        if (result?.status) {
            setCookie("appSystem", "1");
            dispatch(loginTrue());
            // Transmission of successful login information when login is made
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: "loginSuccess", // Event Name
                });
            }
        } else {
            dispatch(loginFalse());
        }
        dispatch(setUserCheckLoading(false));
    };
    return <>{!token || tokenTrue === false ? <WelcomePage /> : null}</>;
};

export default Login;
